"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const cgui_core_atoms_avatar_1 = require("@campgladiator/cgui-core.atoms.avatar");
const cgui_core_atoms_badge_1 = require("@campgladiator/cgui-core.atoms.badge");
const cgui_core_atoms_icon_1 = require("@campgladiator/cgui-core.atoms.icon");
const cgui_core_atoms_tag_1 = require("@campgladiator/cgui-core.atoms.tag");
const cgui_core_atoms_typography_1 = require("@campgladiator/cgui-core.atoms.typography");
const list_item_module_scss_1 = __importDefault(require("./list-item.module.scss"));
const listItemSizeToParagraphSize = {
    small: "xsmall",
    default: "small",
};
const ListItem = (_a) => {
    var { itemId, className, text, active = false, icon, badge, tag, avatar, size = "default", theme = "core", disablePointer, handleActive = () => { }, handleClick = () => { } } = _a, props = __rest(_a, ["itemId", "className", "text", "active", "icon", "badge", "tag", "avatar", "size", "theme", "disablePointer", "handleActive", "handleClick"]);
    const hasAvatar = !!avatar;
    const hasIcon = !!icon;
    const hasBadge = !!badge;
    const hasTag = !!tag;
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)(list_item_module_scss_1.default.item, className, {
            [list_item_module_scss_1.default.active]: active,
            [list_item_module_scss_1.default.disablePointer]: disablePointer,
        }), "data-id": itemId, "data-size": size, "data-theme": theme, onClick: () => {
            handleClick();
            handleActive();
        } }, props),
        hasAvatar && (react_1.default.createElement(cgui_core_atoms_avatar_1.Avatar, { className: list_item_module_scss_1.default.avatar, alt: avatar.alt || undefined, size: "24px", src: avatar.src })),
        (icon === null || icon === void 0 ? void 0 : icon.type) === "solid" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Solid, { className: list_item_module_scss_1.default.icon, name: icon.name })),
        (icon === null || icon === void 0 ? void 0 : icon.type) === "line" && (react_1.default.createElement(cgui_core_atoms_icon_1.Icon.Line, { className: list_item_module_scss_1.default.icon, name: icon.name })),
        react_1.default.createElement(cgui_core_atoms_typography_1.Paragraph, { size: listItemSizeToParagraphSize[size], weight: "book", className: (0, classnames_1.default)(list_item_module_scss_1.default.p, {
                [list_item_module_scss_1.default.extraLeftMargin]: !hasAvatar && !hasIcon,
                [list_item_module_scss_1.default.extraRightMargin]: !hasBadge && !hasTag,
            }) }, text),
        hasTag && (react_1.default.createElement(cgui_core_atoms_tag_1.Tag, { className: list_item_module_scss_1.default.tag, children: tag, size: "tiny", variation: "alternative", emphasis: "primary" })),
        hasBadge && (react_1.default.createElement(cgui_core_atoms_badge_1.Badge, { className: list_item_module_scss_1.default.badge, children: badge, size: "xsmall", emphasis: "primary" }))));
};
exports.default = ListItem;
//# sourceMappingURL=list-item.js.map